import { React, useState, useEffect } from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenToSquare, faTrash } from "@fortawesome/free-solid-svg-icons";
import { Tooltip } from "@mui/material";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import axios from 'axios';
import Swal from "sweetalert2";
import ReactDOMServer from "react-dom/server";

const Facilites = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);

  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;
  const [sortColumn, setSortColumn] = useState('facility_name');
  const [sortOrder, setSortOrder] = useState('asc');


  async function deleteFacility(id) {
    try {
      const loginToken = localStorage.getItem("token");
      const getApiResponse = await axios.delete(`https://api.nvcti.in/facilities/deleteFacility/${id}`,
        {
          headers: {
            Authorization: `Bearer ${loginToken}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (getApiResponse.status == 200) {
        fetchFacilities();
      }
    } catch (error) {
      console.error("Error fetching facilities:", error);
    }
  }

  const handleDelete = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you really want to delete these records?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: ReactDOMServer.renderToString(
        <>
          Yes, delete it!
          <FontAwesomeIcon icon={faTrash} style={{ marginLeft: "10px" }} />
        </>
      ),
      allowOutsideClick: false,
      allowEscapeKey: false,
    }).then((result) => {
      if (result.isConfirmed) {
        deleteFacility(id);
        Swal.fire({
          title: "Deleted!",
          text: "facility record deleted successfully.",
          icon: "success",
          timer: 2000,
          showConfirmButton: false,
        });
      }
    });
  };


  useEffect(() => {
    fetchFacilities();
  }, []);

  const fetchFacilities = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get("https://api.nvcti.in/facilities/getAllFacilities", {
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json"
        }
      });

      //console.log("API Response:", response.data);

      if (!response.data.success) {
        throw new Error(response.data.message || "Failed to fetch facilities");
      }

      const formattedFacilities = response.data.data.map(facility => ({
        id: facility.facility_id,
        facility_name: facility.facility_name,
        location: facility.location,
        capacity: facility.capacity,
        description: facility.description,
        slots_timing: facility.slots_timing,
        start_time: facility.start_time,
        end_time: facility.end_time,
      }));

      setData(formattedFacilities);
    } catch (error) {
      console.error("Error fetching facilities:", error);
    }
  };

  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm]);

  const filteredData = data.filter(item =>
    item.facility_name.toLowerCase().includes(searchTerm.toLowerCase())
    ||
    (item.location && item.location.toLowerCase().includes(searchTerm.toLowerCase()))
  );

  const sortedData = [...filteredData].sort((a, b) => {
    const aValue = a[sortColumn];
    const bValue = b[sortColumn];

    if (aValue && bValue) {
      if (typeof aValue === 'string' && typeof bValue === 'string') {
        return sortOrder === 'asc' ? aValue.localeCompare(bValue) : bValue.localeCompare(aValue);
      }
      if (aValue instanceof Date && bValue instanceof Date) {
        return sortOrder === 'asc' ? aValue - bValue : bValue - aValue;
      }
    }
    return 0;
  });

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = sortedData.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredData.length / itemsPerPage);

  const handleSort = (column) => {
    setSortOrder(prevOrder => (sortColumn === column && prevOrder === 'asc' ? 'desc' : 'asc'));
    setSortColumn(column);
  };
  const userId = localStorage.getItem("user_id");

  return (
    <>
      <div className="relative">
        <div className="flex justify-between items-center px-4 mt-6">
          <p className="font-semibold text-lg text-white">Facility Details</p>
          <div className="flex">
            <Tooltip title="Create Facility" arrow>
              <button
                className="bg-lightBlue-500 text-white active:bg-lightBlue-600 font-semibold text-sm px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none ease-linear transition-all duration-150"
                type="button"
                onClick={(e) => {
                  e.preventDefault();
                  navigate(`/admin/createFacility`, { state: {type:"create", id: userId } });

                  //window.location.href = "/admin/create-facilities";
                }}>
                Create Facility
              </button>
            </Tooltip>
            {/* <Tooltip title="Scan QR" arrow>
              <button
                className="relative text-white bg-blueGray-700 active:bg-blueGray-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none ease-linear transition-all duration-150 ml-6"
                type="button"
                onClick={() => window.location.href = "/admin/scan-qr"}>
                Scan QR
              </button>
            </Tooltip> */}
          </div>
        </div>

        <div className="px-6 mt-4 mb-6">
          <form className="flex flex-row flex-wrap items-center">
            <div className="relative flex w-full flex-wrap items-stretch">
              <span className="z-10 h-full leading-snug font-normal absolute text-center text-white absolute bg-transparent rounded text-base items-center justify-center w-8 pl-3 py-3">
                <i className="fas fa-search"></i>
              </span>
              <Tooltip title="Search Record" arrow>
                <input
                  type="text"
                  placeholder="Search by Facility Name/Amount"
                  className="border-0 px-3 py-3 placeholder-blueGray-400 text-white relative bg-blueGray-700 rounded text-sm shadow outline-none focus:outline-none focus:ring w-full pl-10 pr-10"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)} />
              </Tooltip>
              {searchTerm && (
                <button
                  type="button"
                  onClick={() => setSearchTerm('')}
                  className="absolute right-0 top-0 bottom-0 flex items-center justify-center w-10 text-white hover:text-blueGray-300 focus:outline-none">
                  <i className="fas fa-times"></i>
                </button>
              )}
            </div>
          </form>
        </div>

        <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded bg-blueGray-700">
          <div className="block w-full overflow-x-auto">
            <table className="items-center w-full min-w-full bg-transparent border-collapse">
              <thead>
                <tr>
                  <th className="px-6 min-w-[200px] border py-3 text-sm font-bold text-left bg-blueGray-700 text-white border-blueGray-600">
                    Sr.No
                  </th>
                  <th className="px-6 min-w-[200px] border py-3 text-sm font-bold text-left bg-blueGray-700 text-white border-blueGray-600"
                    onClick={() => handleSort('facility_name')}>
                    Facility Name {sortColumn === 'facility_name' ? (sortOrder === 'asc' ? '↑' : '↓') : ''}
                  </th>
                  <th className="px-6 min-w-[200px] border py-3 text-sm font-bold text-left bg-blueGray-700 text-white border-blueGray-600"
                    onClick={() => handleSort('location')}>
                    Location {sortColumn === 'location' ? (sortOrder === 'asc' ? '↑' : '↓') : ''}
                  </th>
                  {/* Add other columns as needed */}
                  <th className="px-6 min-w-[200px] border py-3 text-sm font-bold text-left bg-blueGray-700 text-white border-blueGray-600">Capacity</th>
                  <th className="px-6 min-w-[200px] border py-3 text-sm font-bold text-left bg-blueGray-700 text-white border-blueGray-600">Start Time</th>
                  <th className="px-6 min-w-[200px] border py-3 text-sm font-bold text-left bg-blueGray-700 text-white border-blueGray-600">End Time</th>
                  {/* <th className="px-4 min-w-[200px] border py-3 text-sm font-bold text-left bg-blueGray-700 text-white border-blueGray-600">Slots timing</th> */}
                  <th className="px-6 min-w-[200px] border py-3 text-sm font-bold text-left bg-blueGray-700 text-white border-blueGray-600">Description</th>
                  <th className="px-6 min-w-[200px] border py-3 text-sm font-bold text-left bg-blueGray-700 text-white border-blueGray-600">Action</th>
                </tr>
              </thead>
              <tbody>
                {currentItems.length ? currentItems.map((item, index) => (
                  <tr key={item.id}>
                    <td className="border-t-0 px-6 align-middle text-xs whitespace-nowrap p-4 text-left border-blueGray-700">
                      <span className="ml-3 font-bold text-white">{(currentPage - 1) * itemsPerPage + index + 1}</span>
                    </td>
                    <td className="border-t-0 px-3 align-middle text-xs whitespace-nowrap p-4 text-left border-blueGray-700">
                      <span className="ml-3 font-bold text-white capitalize">{item.facility_name}</span>
                    </td>
                    <td className="border-t-0 px-6 align-middle text-xs whitespace-nowrap p-4 border-blueGray-700">
                      <span className="ml-3 font-bold text-white">{item.location}</span>
                    </td>
                    <td className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4 border-blueGray-700">
                      <span className="ml-3 font-bold text-white">{item.capacity}</span>
                    </td>
                    <td className="border-t-0 px-4 align-middle text-xs whitespace-nowrap p-4 border-blueGray-700">
                      <span className="ml-3 font-bold text-white">{item.start_time}</span>
                    </td>
                    <td className="border-t-0 px-4 align-middle text-xs whitespace-nowrap p-4 border-blueGray-700">
                      <span className="ml-3 font-bold text-white">{item.end_time}</span>
                    </td>
                    {/* <td className="border-t-0 px-6 align-middle text-xs whitespace-nowrap p-4 border-blueGray-700">
                      <span className="ml-3 font-bold text-white">{item.slots_timing}</span>
                    </td> */}
                    <td className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4 border-blueGray-700" title={item.description}>
                      <div className="flex items-center">
                        <span className="ml-4 font-bold text-white truncate max-w-[150px]">{item.description}</span>
                        {item.description && item.description.length > 30 && (
                          <button
                            onClick={() => Swal.fire({
                              title: 'Facility Description',
                              text: item.description,
                              icon: 'info',
                              background: '#1e293b',
                              color: '#fff',
                              confirmButtonColor: '#3b82f6',
                            })}
                            className="ml-2 text-lightBlue-500 hover:text-lightBlue-400 focus:outline-none"
                            title="View Full Description"
                          >
                            <i className="fas fa-eye"></i>
                          </button>
                        )}
                      </div>
                    </td>
                    <td className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4 text-center flex gap-4">
                      <Tooltip title="Edit" arrow>
                        <motion.button
                          whileHover={{ scale: 1.2, color: "#2563EB" }} // Scales and changes color on hover
                          whileTap={{ scale: 0.9 }}
                          type="button"
                          onClick={() =>{
                              navigate(`/admin/editFacility`, { state: {type:"edit", id: item.id } });
                            }
                          }
                          className="text-blue-500 hover:text-blue-700 focus:outline-none">
                          <FontAwesomeIcon icon={faPenToSquare} className="text-xl" />
                        </motion.button>
                      </Tooltip>

                      <Tooltip title="Delete" arrow>
                        <motion.button
                          whileHover={{ scale: 1.2, color: "#DC2626" }}
                          whileTap={{ scale: 0.9 }}
                          type="button"
                          className="text-blue-500 hover:text-red-700 focus:outline-none mx-4"
                          onClick={() => handleDelete(item.id)}
                        >
                          <FontAwesomeIcon icon={faTrash} className="text-xl" />
                        </motion.button>
                      </Tooltip>
                    </td>
                  </tr>
                )) : <tr>
                  <td colSpan={9} className="text-1xl text-center bg-blueGray-700 text-white font-semibold p-4">
                    No Data Found
                  </td>
                </tr>}
              </tbody>
            </table>
            {/* Pagination buttons */}
          </div>
        </div>
      </div>
    </>
  );
};

export default Facilites;
